import { AppRoutes } from 'navigation/routes';

const App = () => {
  return <AppRoutes />;
};

export default App;
